import { DotLottieWorker, DotLottie } from '@lottiefiles/dotlottie-web'

export const getIosVersion = () => {
  const agent = window.navigator.userAgent
  const start = agent.indexOf('OS')
  if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
    return Number.parseInt(agent.substring(start + 3, 3).replace('_', '.'))
  }
  return null
}

const initAnimations = () => {
  const animations = Array.from(document.querySelectorAll("canvas[data-animation-src]"))
  animations.forEach(async (anim, i) => {
    let src = anim.getAttribute("data-animation-src")
    if (src.startsWith("/")) src = `${window.origin}${src}`
    const iosVersion = getIosVersion()
    // Only ios 16 and above supports OffscreenCanvas
    if (iosVersion === null || iosVersion > 15) {
      new DotLottieWorker({
        canvas: anim,
        loop: true,
        autoplay: true,
        src,
        renderConfig: {
          freezeOnOffscreen: true
        },
        workerId: src + i
      })
    } else {
      new DotLottie({
        canvas: anim,
        loop: true,
        autoplay: true,
        src,
        renderConfig: {
          freezeOnOffscreen: true
        }
      })
    }
  })
}

export default initAnimations